import { render, staticRenderFns } from "./FileExtensionIcons.vue?vue&type=template&id=3e34c4c2&"
import script from "./FileExtensionIcons.vue?vue&type=script&lang=ts&"
export * from "./FileExtensionIcons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports